import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';

export const CategoryListSkeleton = () => {
  return (
    <Wrapper data-testid="categoryList">
      <CategoryListPlaceholders />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 2.125rem;
  width: 100%;
  display: flex;
`;

const placeholders = new Array(4).fill('category-list-placeholder');

const CategoryListPlaceholders: FC = () => {
  return (
    <>
      {placeholders.map((placeholder, i) => (
        <CategoryPlaceholder key={`${placeholder}-${i}`} />
      ))}
    </>
  );
};

const CategoryPlaceholder = styled.div`
  box-sizing: border-box;
  height: 2.125rem;
  width: 26vw;
  background-color: ${COLORS.Grey4};
  border-radius: 2px;
  flex-shrink: 0;
  margin-right: 0.5rem;
`;
